import { Table, Loader } from '@scuf/common';
import 'assets/scuf/datatable/honeywell-compact/theme.css';
import Alert from 'components/alert';
import { formatDate } from 'helpers';
import { RmaModelLiteMf } from 'models';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { RMAMANUFATURA } from 'resources';
import { RmaLiteMf } from 'resources/atoms/rmaManufaturaAtom';
import 'styles/repaircenter.scss';
import useFetch from 'helpers/hooks/useFetch';
import { MicroSigaInvcoiceDTO, MicroSigaBillingDTO } from 'models/spareParts/orderById';

interface Props {
    numberPV: string;
}

const ServiceOrdersAccordion: React.FC<Props> = ({ numberPV }) => {
    const { t } = useTranslation(['common', 'rmamanufatura', 'spareparts']);
    const rmaDetail = useRecoilValue<RmaModelLiteMf>(RmaLiteMf);
    const [pvList, getStatusOrders, loading] = useFetch<{ salesOrderNumber: string }, MicroSigaBillingDTO>({
        url: RMAMANUFATURA.getStatusOrders
    });

    useEffect(() => {
        if (numberPV) {
            getStatusOrders({ salesOrderNumber: numberPV });
        }
    }, [numberPV]);

    return (
        <div className="container">
            {loading ? <Loader text={t('common:actions.Loading')} /> : <div />}
            <>
                <div className="contentPageContainer">
                    <div className="wrap-content">
                        {pvList?.data && pvList?.data.invoices.length > 0 ? (
                            [
                                <div>
                                    <h1>{t('rmamanufatura:translation.Billing') + ' #' + rmaDetail?.numberPV}</h1>
                                    <br />
                                    <Table>
                                        <Table.Header>
                                            <Table.HeaderCell content={t('common:translation.Date')} />
                                            <Table.HeaderCell content={t('common:translation.CurrierName')} />
                                            <Table.HeaderCell content={t('repaircenter:rma.budget.EntryInvoice')} />
                                        </Table.Header>
                                        <Table.Body>
                                            {pvList
                                                ? [
                                                    pvList?.data?.invoices?.map((item: MicroSigaInvcoiceDTO) => (
                                                        <Table.Row>
                                                            <Table.Cell>{formatDate(item?.issued)} </Table.Cell>
                                                            <Table.Cell>{item?.currierName} </Table.Cell>
                                                            <Table.Cell>{item?.invoiceNumber} </Table.Cell>
                                                        </Table.Row>
                                                    ))
                                                ]
                                                : '--'}
                                        </Table.Body>
                                    </Table>
                                    <br />
                                </div>
                            ]
                        ) : (
                            <Alert text={t('common:empty.NoBillingData')} />
                        )}
                    </div>
                </div>
            </>
        </div>
    );
};

export default ServiceOrdersAccordion;
